module.exports = __webpack_public_path__ + "static/media/home2.ee6a6079.png";